// @flow strict

import styles from './About.module.css';

import squirrel from './gouache-squirrel.jpg';

const About = () => (
  <section className={styles.section}>
    <img
      className={styles.img}
      src={squirrel}
      alt="A gouache drawing of a cute furry orange squirrel holding a flower"
    />
    <article className={styles.article}>
      <p>
        Hi!
        <br />
        I'm Rachel Qiuqi 瑞秋琪.
      </p>
      <p>
        After 6 years studying in animation, I chose to focus on illustration for children. With over 10 years of
        experience in drawing, I'm looking forward to telling unique stories through my work.
      </p>
      <p>
        I was born and raised in Shanghai{' '}
        <span role="img" aria-label="China">
          🇨🇳
        </span>
        , and now live in Toronto{' '}
        <span role="img" aria-label="Canada">
          🇨🇦
        </span>
        .
      </p>
      <p>
        My clients include:
        <br />
        Cameron Kids, Quarto Kids, Djeco, Magic Cat Publishing, Greystone Kids, Simon & Schuster, Larousse,
        Fleurus Éditions, Sleeping Bear Press, Gründ Jeunesse, I See Me!, and so on…
      </p>
      <p>
        I enjoy: bread{' '}
        <span role="img" aria-label="bread">
          🍞
        </span>
        , coffee{' '}
        <span role="img" aria-label="coffee">
          ☕
        </span>{' '}
        and swimming{' '}
        <span role="img" aria-label="swimming">
          🏊
        </span>
        <br />I don't enjoy: driving
      </p>
      <p>
        Feel free to shoot me an <a href="mailto:hi@qiuiqi.art">email</a> to share your thoughts!
      </p>
      <p>
        For children's book illustration, please contact my agent Natalie M. Lakosil:{' '}
        <a href="mailto:natalie@lookingglasslit.com">natalie@lookingglasslit.com</a>.
      </p>
    </article>
  </section>
);

export default About;
